import type { DataTableColumn } from '@/components/data-table/data-table.interface'

import type { BillingUsageEntry } from './billing.interface'
import {
  chatNameColumn,
  costAmountColumn,
  createdAtColumn,
  resourceNameColumn,
  stepNameColumn,
  typeColumn,
  userNameColumn,
} from './billing-usage-column.config'

export const usageColumnList: DataTableColumn<BillingUsageEntry>[] = [
  createdAtColumn,
  typeColumn,
  stepNameColumn,
  resourceNameColumn,
  userNameColumn,
  chatNameColumn,
  costAmountColumn,
]
